import { Badge, Group, ScrollArea, Stack, Text } from '@mantine/core'
import { IconHistory } from '@tabler/icons-react'
import { EmptyState } from '../components/EmptyState'
import { EMPTY_COPY } from '../components/empty-copy'
import { RelativeTime } from '../components/Timestamp'
import type { RecentActivityData, WidgetDefinition, WidgetPayload } from '../api/types'

const TYPE_COLOURS: Record<string, string> = {
  authentication: 'blue',
  change: 'indigo',
  access: 'gray',
  system: 'orange',
}

export function RecentActivityWidget({
  payload,
}: {
  definition: WidgetDefinition
  payload: WidgetPayload<RecentActivityData>
}) {
  const { entries } = payload.data

  if (entries.length === 0) {
    return (
      <EmptyState
        compact
        topic="activity"
        icon={<IconHistory />}
        title={EMPTY_COPY.activity.title}
        hint={EMPTY_COPY.activity.hint}
      />
    )
  }

  return (
    <ScrollArea h="100%" type="auto" offsetScrollbars>
      <Stack gap={2}>
        {entries.map((entry) => (
          <Group key={entry.id} justify="space-between" wrap="nowrap" gap="sm" py={5}>
            <Group gap="xs" wrap="nowrap" style={{ minWidth: 0 }}>
              <Badge size="xs" variant="light" color={TYPE_COLOURS[entry.type] ?? 'gray'}>
                {entry.type}
              </Badge>
              <Text size="sm" truncate="end">
                {entry.summary}
              </Text>
            </Group>

            <Group gap="xs" wrap="nowrap" style={{ flexShrink: 0 }}>
              <Text size="xs" c="dimmed">
                {entry.actor_name}
              </Text>
              {/* Relative only: the widget is a narrow "what just happened"
                  list, so the exact stamp stays on hover. The full table shows
                  both. */}
              <RelativeTime value={entry.occurred_at} />
            </Group>
          </Group>
        ))}
      </Stack>
    </ScrollArea>
  )
}
